/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinglink1Inputs */

const en_crosspostinglink1 = /** @type {(inputs: Crosspostinglink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const de_crosspostinglink1 = /** @type {(inputs: Crosspostinglink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

/**
* | output |
* | --- |
* | "Link" |
*
* @param {Crosspostinglink1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinglink1 = /** @type {((inputs?: Crosspostinglink1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinglink1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinglink1(inputs)
	return de_crosspostinglink1(inputs)
});
export { crosspostinglink1 as "crosspostingLink" }